import { ITirPmToltipSetting } from "./interfaces";
import { Directive, DirectiveBinding, ObjectDirective } from "vue";
import { TirPmTooltipPlacementEnum } from "./enums";

type FocusableElement = HTMLElement;
type GenericEventHandler = (
  el: FocusableElement,
  binding: DirectiveBinding
) => void;
interface ExtendedDirective extends ObjectDirective {
  updateTooltip: GenericEventHandler;
}

/**
 * Директива тултипа
 */
export const TooltipDirective = {
  updateTooltip(element: FocusableElement, setting: ITirPmToltipSetting) {
    /**
     * Создание тултипа
     */
    const tooltipElement = document.createElement("div");
    tooltipElement.classList.add("tir-pm-tooltip");
    element.classList.add("tir-pm-tooltip-container");
    /**
     * Создание свг-елемента для стрелки
     */
    const arrowElement = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg"
    );
    arrowElement.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    arrowElement.setAttribute("width", "1.063rem");
    arrowElement.setAttribute("height", "0.5rem");
    arrowElement.setAttribute("viewBox", "0 0 1.063 0.5");
    arrowElement.classList.add("tir-pm-tooltip-arrow");
    /**
     * Вставка созданного элемента в родительский компонент, определенный через директиву (v-ttoltip)
     */
    element.append(tooltipElement);
    /**
     * Определение позиции
     */
    if (setting?.theme?.placement) {
      tooltipElement.classList.add(
        `tir-pm-tooltip--placement-${setting.theme.placement}`
      );
    } else {
      tooltipElement.classList.add(
        `tir-pm-tooltip--placement-${TirPmTooltipPlacementEnum.Top}`
      );
    }
    /**
     * Определение цвета
     */
    if (setting?.theme?.variant) {
      tooltipElement.classList.add(`tir-pm-tooltip--${setting.theme.variant}`);
    } else {
      tooltipElement.classList.add(`tir-pm-tooltip--default`);
    }
    /**
     * Присвоение текста
     */
    if (setting.text) {
      tooltipElement.textContent = setting.text;
      arrowElement.innerHTML =
        "<path d='M0.500488 0L16.5005 3.17468e-08L8.48459 8L0.500488 0Z' fill='currentColor'/>";
      tooltipElement.append(arrowElement);
    } else {
      console.warn(
        'Не хватает дефолтного контента под ключом "text". Посмотрите модель компонента для правильной настройки. '
      );
    }
  },
  /**
   * Привязка и инициализация
   */
  mounted(element: FocusableElement, binding: DirectiveBinding) {
    (binding.dir as ExtendedDirective).updateTooltip(element, binding.value);
  },
  updated(element: FocusableElement, binding: DirectiveBinding) {
    const thisDirective = binding.dir as ExtendedDirective;
    thisDirective.updateTooltip(element, binding.value);
    console.log(binding.value, 1212);
  },
} as Directive;

export default TooltipDirective;
